export default "__VITE_ASSET__BDkRyE41__"